import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_search.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-eeed3982")

_pushScopeId("data-v-eeed3982")
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "truncate" }
const _hoisted_3 = {
  key: 0,
  class: "absolute top-full left-0 mt-1 w-80 bg-white border border-gray-lp-400 rounded-lg shadow-lg z-50"
}
const _hoisted_4 = { class: "px-4 py-3 border-b border-gray-lp-400" }
const _hoisted_5 = { class: "font-semibold text-gray-800 text-base" }
const _hoisted_6 = { class: "px-4 py-3" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-lp-300",
  alt: "search"
}, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "border-b border-gray-lp-400"
}
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "flex items-center justify-center gap-2" }
const _hoisted_12 = {
  key: 0,
  class: "px-4 py-8 text-center text-gray-500"
}
const _hoisted_13 = { class: "font-semibold text-gray-800" }
const _hoisted_14 = {
  key: 1,
  class: "px-4 py-2"
}
const _hoisted_15 = { class: "space-y-1" }
const _hoisted_16 = { class: "flex-1" }
const _hoisted_17 = { class: "font-medium text-gray-900" }
const _hoisted_18 = {
  key: 2,
  class: "px-4 py-8 text-center text-gray-500"
}
const _hoisted_19 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_20 = { class: "font-semibold text-gray-800" }
const _hoisted_21 = {
  key: 3,
  class: "px-4 py-8 text-center text-gray-500"
}
const _hoisted_22 = { class: "font-semibold text-gray-800" }
const _hoisted_23 = {
  key: 4,
  class: "px-4 py-2 text-center text-gray-500"
}
const _hoisted_24 = { class: "text-sm text-gray-600" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
      class: ["flex items-center justify-between w-full px-3 py-2 bg-white border border-gray-lp-400 rounded-md text-left text-sm", { 'border-red-500': _ctx.isOpen }]
    }, [
      _createVNode("span", _hoisted_2, _toDisplayString(_ctx.selectedItem ? _ctx.selectedItem.label : _ctx.placeholder), 1),
      _createVNode("img", {
        src: _ctx.isOpen ? _ctx.chevronUpIcon : _ctx.chevronDownIcon,
        class: "w-4 h-4 ml-2",
        alt: "chevron"
      }, null, 8, ["src"])
    ], 2),
    (_ctx.isOpen)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("h3", _hoisted_5, _toDisplayString(_ctx.headerText), 1)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createVNode("input", {
                ref: "searchInput",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchQuery = $event)),
                type: "text",
                placeholder: _ctx.searchPlaceholder,
                class: "bg-gray-100 w-full pl-10 pr-3 py-2 border border-gray-lp-400 rounded-md text-sm focus:outline-none focus:shadow"
              }, null, 8, ["placeholder"]), [
                [_vModelText, _ctx.searchQuery]
              ])
            ])
          ]),
          (_ctx.showTab)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                    return (_openBlock(), _createBlock("button", {
                      key: category.key,
                      onClick: ($event: any) => (_ctx.setActiveTab(category.key)),
                      class: ["flex-1 px-4 py-3 text-sm font-medium text-center border-b-2 transition-colors", 
              _ctx.activeTab === category.key
                ? 'border-red-500 text-red-600'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            ]
                    }, [
                      _createVNode("div", _hoisted_11, [
                        _createVNode("img", {
                          src: category.icon,
                          class: "w-4 h-4",
                          alt: category.label
                        }, null, 8, ["src", "alt"]),
                        _createTextVNode(" " + _toDisplayString(category.label), 1)
                      ])
                    ], 10, ["onClick"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", {
            class: "max-h-64 overflow-y-auto",
            onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
          }, [
            (_ctx.showMinimumCharMessage)
              ? (_openBlock(), _createBlock("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, _toDisplayString(_ctx.minimumCharMessage), 1)
                ]))
              : (_ctx.currentTabData.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentTabData, (item) => {
                        return (_openBlock(), _createBlock("div", {
                          key: `${_ctx.activeTab}-${item.id}`,
                          class: "flex items-center gap-3 p-2 hover:bg-gray-lp-100 rounded cursor-pointer",
                          onClick: ($event: any) => (_ctx.selectItem(item))
                        }, [
                          _createVNode("div", _hoisted_16, [
                            _createVNode("div", _hoisted_17, _toDisplayString(item.label), 1),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getItemFields(item), (field) => {
                              return (_openBlock(), _createBlock("div", {
                                key: field.key,
                                class: field.className || 'text-sm text-gray-500 mt-1'
                              }, _toDisplayString(_ctx.getFieldValue(field, item)), 3))
                            }), 128))
                          ])
                        ], 8, ["onClick"]))
                      }), 128))
                    ])
                  ]))
                : (_ctx.currentTabData.length === 0 && !_ctx.isLoading)
                  ? (_openBlock(), _createBlock("div", _hoisted_18, [
                      (_ctx.currentEmptyImage)
                        ? (_openBlock(), _createBlock("div", _hoisted_19, [
                            _createVNode("img", {
                              src: _ctx.currentEmptyImage,
                              class: "mx-auto w-32 h-32 object-contain",
                              alt: "No results"
                            }, null, 8, ["src"])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_20, _toDisplayString(_ctx.currentEmptyText), 1)
                    ]))
                  : _createCommentVNode("", true),
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("dispatch.loading")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isLoadingData(_ctx.activeTab))
              ? (_openBlock(), _createBlock("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("dispatch.loadingMore")), 1)
                ]))
              : _createCommentVNode("", true)
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside, _ctx.closeDropdown]
  ])
})